import React, {Suspense} from 'react';
import BaseLayer from "./BaseLayer";
import {drawLine, imagetoCanvasPosHelper} from "../utils/map_utils";
import {Grid} from "@mui/material";
const Plot = React.lazy(() => import("react-plotly.js"));

class TiltFocusPair extends BaseLayer {
    id = "tiltFocusPair";
    label = "Tilt Focus Pairs";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {tiltFocusPairs} = this.props;
        console.debug("tiltFocusPairs", tiltFocusPairs);
        this.drawPlotLink(tiltFocusPairs["horizontalPair"], true);
        this.drawPlotLink(tiltFocusPairs["verticalPair"], false);
        resolve();
    });

    drawPlotLink = (focusPairData, horizontal) => {
        let {x_fields, tile_height, uperpixel} = this.props.slide;
        let {deviceSettings, textColor} = this.props;
        console.debug("focusPair", focusPairData);
        const orderedCellKeys = focusPairData['orderedCellKeys'];
        const firstCellKey = orderedCellKeys[0];
        let xImagePos = parseInt(firstCellKey.split("y")[0].split("x")[1]);
        let yImagePos = parseInt(firstCellKey.split("y")[1]);

        let abDistances = focusPairData['abDistances'];
        let maxVal = Math.max(...abDistances);
        let minVal = Math.min(...abDistances);
        abDistances = abDistances.map(dist => (dist - minVal)/(maxVal - minVal));
        
        let lDistances = focusPairData['ldistances'];
        let maxVall = Math.max(...lDistances);
        let minVall = Math.min(...lDistances);
        lDistances = lDistances.map(dist => (dist - minVall)/(maxVall - minVall));

        var trace1 = {
            x: orderedCellKeys,
            y: abDistances,
            type: 'scatter',
            name: 'AB Distances',
        };
        console.debug("abDistances", abDistances);
        var trace2 = {
            x: orderedCellKeys,
            y: lDistances,
            type: 'scatter',
            name: 'L Distances',
        };

        var bestPairAB = {
            x: [focusPairData['bestUsingAbDist1'], focusPairData['bestUsingAbDist2']],
            y: [1.0, 1.0],
            mode: 'markers',
            name: 'AB Dist. Best Pair',
            text: ['Left Cell', 'Right Cell'],
            marker: {
                color: 'rgb(142, 124, 195)',
                size: 12
            },
            type: 'scatter'
        };

        var bestPairL = {
            x: [focusPairData['bestUsingLDist1'], focusPairData['bestUsingLDist2']],
            y: [1.2, 1.2],
            mode: 'markers',
            name: 'L Dist. Best Pair',
            text: ['Left Cell', 'Right Cell'],
            marker: {
                color: 'rgb(255, 217, 102)',
                size: 12
            },
            type: 'scatter'
        };

        var data = [trace1, trace2, bestPairAB, bestPairL];
        var layout = {
            title:'AB and L Distance Plot'
        };

        let popup = 
            <Grid>
                <Suspense fallback={<div>Loading...</div>}>
                    <Plot data={data}
                        layout={layout}/>
                </Suspense>
            </Grid>;
        
        let {x, y} = imagetoCanvasPosHelper({device_settings: deviceSettings}, this.props.slide, x_fields - xImagePos, yImagePos);
        let radius = 10;
        drawLine(x + 0.5 * tile_height * uperpixel - radius, y - 0.5 * tile_height * uperpixel - radius, 1, this.layer.getSource(),
                    `[PLOT ${horizontal ? "H" : "V"} Pair]`, 10, "#f4c2c2", popup, textColor, 10);
    }
}

export default TiltFocusPair;